import Dropdown from "react-bootstrap/Dropdown";
import "./points-of-sale-filter.scss";
import { useState, useEffect } from "react";
import langs from "../../../common/services/languageService";

const { labels } = langs;

function PointsOfSaleFilter({
  onFilterByOffer,
  selectedOfferFilter,
  posOffers: offers,
}) {
  useEffect(() => {
    if (offers.length === 1) {
      onFilterByOffer(offers[0]);
    }
  }, [offers, onFilterByOffer]);

  const handleSelect = (offerKey) => {
    if(offerKey === "all") offerKey = null;
    onFilterByOffer(offerKey);
  };

  const toggleLabel =
    offers.length === 1
      ? offers[0]
      : selectedOfferFilter || labels.SelectOffer();

  return (
    <div>
      <div className="d-flex px-5 px-sm-5 smallContainer justify-content-center">
        <Dropdown className="mx-3 mx-sm-5 my-3" onSelect={handleSelect}>
          <Dropdown.Toggle id="dropdown-basic" className="fs-6">
            {toggleLabel}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {offers.length > 1 && (
              <Dropdown.Item key={"all"} eventKey={"all"}>
                {labels.AllOffers()}
              </Dropdown.Item>
            )}
            {offers.map((offer) => (
              <Dropdown.Item key={offer} eventKey={offer}>
                {offer}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}

export default PointsOfSaleFilter;
